import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { get, post, put } from "@utils/axios_api";
import { AuthHook } from "@hooks";

const fetchUserList = async () => {
  const response = await get("/lecture/userList");
  return response;
};

export function useLectureUserModal(isOpen) {
  const { auth } = AuthHook();
  const queryClient = useQueryClient();
  
  const { data:userInfo } = useQuery(
    ["selectLectureUserListModal"],
    fetchUserList,
    { enabled: isOpen && auth.isAuthenticated }
  );

  const searchBiz = async (bizRegNo) =>
    get('/lecture/company', {params: {bizRegNo:bizRegNo}});


  const applyMutation = useMutation(
    (payload) => post("/lecture/apply", payload),
    {
      onSuccess: () => queryClient.invalidateQueries(["selectLectureUserListModal"]),
    }
  );

  return {
    userInfo, applyMutation, searchBiz,
  };
}
